import * as React from "react"

// This is a typescript work around found in the react-to-print issues: https://github.com/gregnb/react-to-print/issues/136
export class EmptyComponent extends React.Component {
    render() {
        return null
    }
}